import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AnyoComponent } from 'projects/app-core/src/app/models/AnyoComponent';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import {
  AdminActivateAnyoPackageRequest,
  PackService,
} from '../../../services/packs.service';
import { AnyoPacksGridRequest } from '../../../models/packs/AnyoPacksGridRequest';
import { AnyoPackGridResponseData } from '../../../models/packs/AnyoPacksGridResponse';
import { GenericMasterData } from '../../../models/masterDataResponse';
import { MasterdataService } from '../../../services/masterdata.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TherapistService } from '../../../services/therapist.service';
import { TherapistGridRequest } from '../../../models/therapistGridRequest';

import { getFullName } from 'projects/app-core/src/app/utils/utils';
@Component({
  selector: 'app-manage-anyo-packs',
  templateUrl: './manage-anyo-packs.component.html',
  styleUrl: './manage-anyo-packs.component.scss',
})
export class ManageAnyoPacksComponent extends AnyoComponent {
  constructor(
    auth: AuthService,
    private toastService: ToastService,
    private router: Router,
    private packService: PackService,
    private masterdataService: MasterdataService,
    private fb: FormBuilder,
    private therapistService: TherapistService,
  ) {
    super(auth);
    this.addPackSubscriptionForm = this.fb.group({
      userEmail: ['', [Validators.required, Validators.email]],
      paymentOrderId: ['', Validators.required],
      variationId: [null, Validators.required],
      auxiliaryConcernId: [null, Validators.required],
      primaryTherapistId: [null, Validators.required],
      auxiliaryTherapistId: [null, Validators.required],
      auxiliaryPackExpertiseIds: [null, Validators.required],
    });
  }
  page: number = 1;
  pageSizeOptions = [10, 20,50,100];
  globalSearchInput: string = '';
  tableLoading: boolean = false;
  tableData: AnyoPackGridResponseData[] = [];
  totalRecords: number = 0;
  pageSize: number = 10;
  concernMasterData: GenericMasterData[] = [];
  isVisible: boolean = true;
  isActive: boolean = true;
  packId: string = '';
  testPacks: boolean = false;
  openAddPackSubscriptionDrawer: boolean = false;
  addPackSubscriptionForm: FormGroup;
  drawerLoading: boolean = false;

  variationOptions: {
    label: string;
    value: string;
  }[] = [];

  auxiliaryConcernOptions: {
    label: string;
    value: string;
  }[] = [];

  therapistOptions: {
    label: string;
    value: string;
  }[] = [];

  auxiliaryTherapistOptions: {
    label: string;
    value: string;
  }[] = [];

  packExpertiseOptions: { label: string; value: string }[] = [];

  async ready() {
    await this.loadMasterData();
    if (this.user) {
      await this.fetchAnyoPacks();
      await this.fetchTherspist();
    }
  }

  async loadMasterData(): Promise<void> {
    this.masterdataService.masterDataList().subscribe({
      next: (masterData) => {
        this.concernMasterData = masterData.therapyConcerns;
        this.auxiliaryConcernOptions = masterData.therapyConcerns.map(
          (data) => ({
            label: data.data,
            value: data.m_id,
          }),
        );
        console.log(masterData);
        this.packExpertiseOptions =
          masterData.therapyPackExpertise?.map((data) => ({
            label: data.data,
            value: data.m_id,
          })) || [];
      },
    });
  }

  getConcernNameById(id: string) {
    if (this.concernMasterData.length < 0) {
      this.loadMasterData();
    }
    const concern = this.concernMasterData.find((data) => data.m_id === id);
    return concern?.data;
  }
  getConcernNames(ids: string[]): string[] {
    return ids
      .map((id) => this.getConcernNameById(id))
      .filter((name): name is string => !!name);
  }

  async fetchAnyoPacks() {
    this.tableLoading = true;
    const req: AnyoPacksGridRequest = {
      page: this.page,
      pageSize: this.pageSize,
      filters: {
        NAME: [],
        VISIBLE: [this.isVisible ? 'true' : 'false'],
        ACTIVE: [this.isActive ? 'true' : 'false'],
        CONCERN: [],
        HIDE_TEST: [this.testPacks ? 'true' : 'false'],
      },
      globalSearch: [],
      export: false,
    };
    if (this.globalSearchInput) {
      req.globalSearch = [this.globalSearchInput];
    }
    this.packService.getPacksGrid(req).subscribe({
      next: (value) => {
        this.tableData = value.data;
        this.tableData.forEach((data) => {
          console.log(data.auxilaryTherapistDetails);
        })
        this.totalRecords = value.totalRecords;
        this.pageSize = value.pageSize;
        this.tableLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.tableLoading = false;
      },
      complete: () => {
        this.tableLoading = false;
      },
    });
  }

  async fetchTherspist() {
    const req: TherapistGridRequest = {
      page: 1,
      pageSize: 100,
      export: false,
    };
    this.therapistService.listTherapist(req).subscribe({
      next: (value) => {
        this.auxiliaryTherapistOptions = value.data.map((data) => ({
          label: getFullName(data.firstName, data.lastName),
          value: data.id!,
        }));
      },
      error: () => {
        this.toastService.showAnyoErrorToast('Error while fetching therapist');
      },
    });
  }

  resetFilter() {
    this.page = 1;
    this.globalSearchInput = '';
    this.fetchAnyoPacks();
  }

  testPacksChangeFn($event: boolean) {
    this.page = 1;
    this.testPacks = $event;
    this.fetchAnyoPacks();
  }

  nzPageIndexChange($event: number) {
    this.page = $event;
    this.fetchAnyoPacks();
  }
  nzPageSizeChange($event: number) {
    this.pageSize = $event;
    this.fetchAnyoPacks();
  }
  openTherapyPlansSubscriptionPageByPlanName(packId: string) {
    window.open(`packs/subscription?packId=${packId}`);
  }
  onToggleVisible($event: boolean) {
    this.isVisible = $event;
    this.fetchAnyoPacks();
  }
  onToggleActive($event: boolean) {
    this.isActive = $event;
    this.fetchAnyoPacks();
  }

  onAddSubscription(packId: string) {
    this.packId = packId;
    this.packService.getPack(packId).subscribe({
      next: (pack) => {
        this.variationOptions = pack.variations.map((variation) => ({
          label: variation.variantName,
          value: variation.id!,
        }));
        this.therapistOptions = pack.therapistDetails!.map((therapist) => ({
          label: therapist.name,
          value: therapist.id,
        }));
        this.auxiliaryTherapistOptions = this.auxiliaryTherapistOptions?.filter(
          (therapist) =>
            !pack.therapistDetails!.some((t) => t.id === therapist.value),
        );
        console.log(this.auxiliaryTherapistOptions);
        console.log(
          this.auxiliaryTherapistOptions?.filter(
            (therapist) =>
              !pack.therapistDetails!.some((t) => t.id === therapist.value),
          ),
        );
        console.log(pack);
        this.openAddPackSubscriptionDrawer = true;
      },
    });
  }

  handleCloseDrawer() {
    this.openAddPackSubscriptionDrawer = false;
  }
  onSubmit() {
    this.drawerLoading = true;
    if (this.addPackSubscriptionForm.valid) {
      console.log('Form Data:', this.addPackSubscriptionForm.value);
      const req: AdminActivateAnyoPackageRequest = {
        userEmail: this.addPackSubscriptionForm.value.userEmail,
        packId: this.packId,
        variationId: this.addPackSubscriptionForm.value.variationId,
        auxiliaryConcernId:
          this.addPackSubscriptionForm.value.auxiliaryConcernId,
        primaryTherapistId:
          this.addPackSubscriptionForm.value.primaryTherapistId,
        auxiliaryTherapistId:
          this.addPackSubscriptionForm.value.auxiliaryTherapistId,
        auxiliaryPackExpertiseIds:
          this.addPackSubscriptionForm.value.auxiliaryPackExpertiseIds,
        paymentOrderId: this.addPackSubscriptionForm.value.paymentOrderId,
      };
      this.packService.adminActivatePackSubscription(req).subscribe({
        next: () => {
          this.toastService.showInfo('Pack subscription activated');
          this.addPackSubscriptionForm.reset();
          this.handleCloseDrawer();
        },
        error: (error) => {
          this.toastService.showAnyoErrorToast(error.error.description);
          this.drawerLoading = false;
        },
      });
    }
  }
}
